<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
      <h1 class="h3 mb-0">{{ $t('Cost Prices') }}</h1>
    </div>
    <b-tabs size="lg" horizontal active-nav-item-class="active">
      <b-tab
        v-for="tab in tabs"
        :key="tab.name"
        @click="onTabChange(tab.name)"
        :active="currentTab.includes(tab.name)"
      >
        <template #title>
          <span>{{ tab.title }}</span>
        </template>
      </b-tab>

      <b-card no-body>
        <b-card-body>
          <router-view />
        </b-card-body>
      </b-card>
    </b-tabs>
  </div>
</template>
<script>
import { BTabs, BTab, BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'CostsPricesManagement',
  components: {
    BTabs,
    BTab,
    BCard,
    BCardBody
  },

  data() {
    return {
      tabs: [
        {
          name: 'cost-prices-unit-prices',
          title: this.$t('Unit Prices'),
          heading: this.$t('Unit Prices')
        },
        {
          name: 'cost-prices-additional-services',
          title: this.$t('Additional Services'),
          heading: this.$t('Additional Services')
        },
        {
          name: 'cost-prices-additional-fees',
          title: this.$t('Additional Fees'),
          heading: this.$t('Additional Fees')
        },
        {
          name: 'cost-prices-rules',
          title: this.$t('Rules'),
          heading: this.$t('Rules')
        },
        {
          name: 'cost-prices-instructions',
          title: this.$t('Instructions'),
          heading: this.$t('Instructions')
        },
        {
          name: 'cost-prices-consignor-prices',
          title: this.$t('Prices of the Consignor'),
          heading: this.$t('Prices of the Consignor')
        }
      ],
      currentTab: 'cost-prices-additional-fees'
    };
  },

  methods: {
    onTabChange(name) {
      this.currentTab = name;
      this.$router.push({ name });
    }
  },

  watch: {
    '$route.name': {
      handler(newName) {
        this.currentTab = newName;
      },
      immediate: true
    }
  }
};
</script>
